module.exports = __webpack_public_path__ + "img/washing.5bca2ba5.svg";